<div class="grp">

  <!-- Header -->
  <header class="grp__header">
    <div>
      <h1 class="grp__title">
        <i class="fa-solid fa-users grp__title-icon"></i>
        {{ 'GROUPS.TITLE' | translate }}
      </h1>
      <p class="grp__subtitle">{{ 'GROUPS.SUBTITLE' | translate }}</p>
    </div>
    <span class="grp__count">
      {{ 'GROUPS.COUNT' | translate:{ count: filteredGroups().length } }}
    </span>
  </header>

  <!-- Search -->
  <div class="grp__search">
    <i class="fa-solid fa-magnifying-glass"></i>
    <input type="search"
           [value]="query()"
           (input)="onSearch($any($event.target).value)"
           [placeholder]="'GROUPS.SEARCH_PLACEHOLDER' | translate"
           aria-label="Search">
  </div>

  <!-- Loading skeleton -->
  <div *ngIf="loading()" class="grp__skeleton">
    <div class="grp__skel-row" *ngFor="let _ of [1,2,3]"></div>
  </div>

  <!-- Layout : list (left) + details (right) -->
  <ng-container *ngIf="!loading()">

    <!-- Erreur de chargement : jamais de données de substitution -->
    <app-error-state *ngIf="errored()"
                     titleKey="GROUPS.ERROR_TITLE"
                     messageKey="GROUPS.ERROR_DESC"
                     (retry)="reload()"></app-error-state>

    <ng-container *ngIf="!errored()">
    <div class="grp__layout"
         [class.grp__layout--with-detail]="selectedGroup() !== null">

      <!-- Groups list -->
      <ul class="grp__list" *ngIf="filteredGroups().length > 0; else emptyTpl">
        <li *ngFor="let g of filteredGroups()"
            class="grp__card"
            [class.is-selected]="selectedGroup()?.id === g.id"
            [class.is-inactive]="g.isActive === false"
            (click)="selectGroup(g)">
          <div class="grp__card-icon">
            <i class="fa-solid fa-users"></i>
          </div>
          <div class="grp__card-main">
            <h3 class="grp__card-name">{{ g.name }}</h3>
            <p class="grp__card-desc" *ngIf="g.description">{{ g.description }}</p>
            <ul class="grp__card-meta">
              <li *ngIf="g.learningPathTitle">
                <i class="fa-solid fa-graduation-cap"></i>
                {{ g.learningPathTitle }}
              </li>
              <li *ngIf="g.memberCount != null">
                <i class="fa-solid fa-user-group"></i>
                {{ g.memberCount }}
                {{ (g.memberCount === 1 ? 'GROUPS.MEMBER' : 'GROUPS.MEMBERS_PLURAL') | translate }}
              </li>
              <li *ngIf="g.isActive === false">
                <i class="fa-solid fa-circle-exclamation"></i>
                {{ 'GROUPS.INACTIVE' | translate }}
              </li>
            </ul>
          </div>
          <i class="fa-solid fa-chevron-right grp__card-arrow"></i>
        </li>
      </ul>

      <!-- Details panel -->
      <aside class="grp__detail" *ngIf="selectedGroup() as g">
        <button class="grp__close" type="button"
                (click)="closeDetails()"
                [attr.aria-label]="'COMMON.CLOSE' | translate">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <div class="grp__detail-head">
          <div class="grp__detail-icon">
            <i class="fa-solid fa-users"></i>
          </div>
          <div>
            <h2 class="grp__detail-name">{{ g.name }}</h2>
            <p class="grp__detail-meta" *ngIf="g.learningPathTitle">
              <i class="fa-solid fa-graduation-cap"></i>
              {{ g.learningPathTitle }}
            </p>
          </div>
        </div>

        <p class="grp__detail-desc" *ngIf="g.description">{{ g.description }}</p>

        <h3 class="grp__detail-section">
          {{ 'GROUPS.MEMBERS_LIST' | translate }}
          <span *ngIf="!loadingMembers()" class="grp__detail-section-count">
            ({{ members().length }})
          </span>
        </h3>

        <div *ngIf="loadingMembers()" class="grp__skeleton">
          <div class="grp__skel-row" *ngFor="let _ of [1,2,3]"></div>
        </div>

        <app-error-state *ngIf="!loadingMembers() && membersErrored()"
                         titleKey="GROUPS.MEMBERS.ERROR_TITLE"
                         messageKey="GROUPS.MEMBERS.ERROR_DESC"
                         (retry)="reloadMembers()"></app-error-state>

        <ul class="grp__members" *ngIf="!loadingMembers() && !membersErrored()">
          <li *ngFor="let m of members()" class="grp__member">
            <div class="grp__member-avatar">
              {{ (m.studentFullName ?? '?').charAt(0).toUpperCase() }}
            </div>
            <div class="grp__member-main">
              <div class="grp__member-name">{{ m.studentFullName }}</div>
              <div class="grp__member-sub" *ngIf="m.studentCode">
                <span>{{ m.studentCode }}</span>
                <span *ngIf="m.studentEmail">· {{ m.studentEmail }}</span>
              </div>
            </div>
          </li>
          <li *ngIf="members().length === 0" class="grp__member-empty">
            {{ 'GROUPS.NO_MEMBERS' | translate }}
          </li>
        </ul>
      </aside>
    </div>

    <!-- Empty -->
    <ng-template #emptyTpl>
      <div class="grp__empty">
        <div class="grp__empty-icon"><i class="fa-solid fa-users-slash"></i></div>
        <h3>{{ 'GROUPS.EMPTY_TITLE' | translate }}</h3>
        <p>{{ 'GROUPS.EMPTY_DESC' | translate }}</p>
      </div>
    </ng-template>
    </ng-container>

  </ng-container>

</div>
